import { Box, Typography, Skeleton } from '@mui/material'
import { useGetEmployeeEntitlement } from 'services/api/modules/leave/entitlement'
import EmptyData from 'module/leave/pages/createRequest/components/emptyData'
import LeaveBalanceCardList, {
  LeaveBalanceCardReplacement,
} from '../components/leaveBalanceCardList'

const LeaveBalanceCard = () => {
  const { data: entitlementData, isLoading } = useGetEmployeeEntitlement()

  let array = new Array(3).fill('i')

  return (
    <Box
      sx={{
        backgroundColor: 'white.main',
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        border: 1,
        borderColor: 'gray-line.main',
        borderRadius: '4.5px',
      }}
    >
      <Box sx={{ p: 2 }}>
        <Typography variant="subtitle1" color="dark-text.main">
          My leave balance
        </Typography>
        <Typography variant="body2" color="light-gray-text.main">
          Your leave balance for the current year
        </Typography>
      </Box>
      <Box sx={{ p: 2 }}>
        {entitlementData ? (
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              overflow: 'auto',
              maxHeight: 'calc(100vh - 236px)',
            }}
            className="scrollbar"
          >
            {/* For Leave with entitlement */}
            {isLoading ? (
              array.map((arr, index) => (
                <Box key={index} width={'100%'} sx={{ display: 'flex' }}>
                  <Box width={3 / 4}>
                    <Skeleton height={40} />
                  </Box>
                  <Box width={1 / 4} sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                    <Skeleton width={'80%'} height={40} />
                  </Box>
                </Box>
              ))
            ) : entitlementData?.with_entitlement?.length ? (
              <>
                <Typography variant="body2" color="light-gray-text-2.main">
                  Leave with entitlement
                </Typography>
                {entitlementData?.with_entitlement?.map((item, index) => (
                  <LeaveBalanceCardList
                    key={index}
                    item={item}
                    index={index}
                    list={entitlementData}
                  />
                ))}
              </>
            ) : null}
            {/* For Leave without entitlement */}
            {isLoading ? (
              array.map((arr, index) => (
                <Box key={index} width={'100%'} sx={{ display: 'flex' }}>
                  <Box width={3 / 4}>
                    <Skeleton height={40} />
                  </Box>
                  <Box width={1 / 4} sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                    <Skeleton width={'80%'} height={40} />
                  </Box>
                </Box>
              ))
            ) : entitlementData?.without_entitlement?.length ? (
              <>
                <Typography variant="body2" color="light-gray-text-2.main">
                  Leave without entitlement
                </Typography>
                {entitlementData?.without_entitlement?.map((item, index) => (
                  <LeaveBalanceCardList
                    key={index}
                    item={item}
                    index={index}
                    list={entitlementData}
                  />
                ))}
              </>
            ) : null}

            {/* For Replacement Credit */}
            {isLoading ? (
              <Box width={'100%'} sx={{ display: 'flex' }}>
                <Box width={1 / 2}>
                  <Skeleton height={40} width={'100%'} />
                </Box>
                <Box
                  sx={{
                    width: 1 / 2,
                    display: 'flex',
                    justifyContent: 'flex-end',
                  }}
                >
                  <Skeleton height={40} width={'100%'} />
                </Box>
              </Box>
            ) : entitlementData?.leave_credit?.length ? (
              <>
                <Typography variant="body2" color="light-gray-text-2.main">
                  Other
                </Typography>
                <LeaveBalanceCardReplacement
                  item={entitlementData?.leave_credit[0]}
                  list={entitlementData}
                />
              </>
            ) : null}
          </Box>
        ) : (
          <EmptyData
            icon={'calendar_today'}
            title="No Leave Policies Found"
            message="Please proceed to company management to create new leave policies"
            sx={{ minHeight: '70vh' }}
          />
        )}
      </Box>
    </Box>
  )
}

export default LeaveBalanceCard
